module.exports = __webpack_public_path__ + "static/customize-phone-2@2x-12cd19aaac1c9671afe6a55b96a0cc8a.png";